import React, { useEffect, useRef, useState } from "react"
import Slider from "react-slick"
import * as styles from "./timelineContainer.module.scss"
import person1 from "../../images/person_1.png"
import car from "../../images/car.png"
import cup from "../../images/cup.png"
import sign from "../../images/signature.png"
import person2 from "../../images/person_2.png"
import sign2 from "../../images/signature_2.png"
import bg from "../../images/bg.png"
import group from "../../images/Group.png"
import progress from "../../images/progress.png"
import log from "../../images/log.png"
import pg_logo from "../../images/pg_logo.png"
import redLabel from "../../images/redLabel.png"
import redLabelLogo from "../../images/redLabelLogo.png"
import bushells from "../../images/bushells.png"
import bushellsLogo from "../../images/bushellsLogo.png"
import carton from "../../images/carton.png"
import teaBag from "../../images/teaBag.png"
import glass from "../../images/glass.png"
import carton2 from "../../images/carton2.png"
import teaBag2 from "../../images/teaBag2.png"
import seal from "../../images/seal.png"
import carton3 from "../../images/carton3.png"
import teaBag3 from "../../images/teaBag3.png"
import liptonLogo from "../../images/liptonLogo.png"
import tazo from "../../images/tazo.png"
import pg_green from "../../images/pg_green.png"
import ekaterra_logo from "../../images/ekaterra_logo.png"
import { motion } from "framer-motion"
import bg2 from "../../images/bg2.png"
import group2 from "../../images/group2.png"
import Img from "gatsby-image"
import bannerbg from "../../images/banner_bg.png"
import skip_notif from "../../images/skip_notif.png"
import drag_notif from "../../images/drag_notif.png"
import ekaterra_tl from "../../images/ekaterra_tl.png"
import "../../fonts/Bilo/Bilo Bold.otf"
import "../../fonts/Bilo/Bilo Medium.otf"
import { useWindowWidth } from "../../hooks/layout/useWindowWidth"
import { useAnimationContent } from "../../hooks"

const TimelineContainer = () => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isTimelineWhite, setIsTimelineWhite] = useState(true)
  const [currentEra, setCurrentEra] = useState("")
  const [showSkipNotification, setShowSkipNotification] = useState(false)
  const [showDragNotification, setShowDragNotification] = useState(false)
  const sliderRef = useRef()
  
  const animation_content = useAnimationContent()
  const textPresent  = animation_content.textPresent ? animation_content.textPresent : "Present"

  const mergeLeverBrothers = []
  animation_content.mergeLeverBrothers.map(({heading})=>{
    mergeLeverBrothers.push(heading)
  })
  const liptonIceTea = []
  animation_content.liptonIceTea.map(({heading})=>{
    liptonIceTea.push(heading)
  })
  const tazoHeading = []
  animation_content.tazo.map(({heading})=>{
    tazoHeading.push(heading)
  })
  
  

  const datesArray = [
    "",
    "1869",
    "1890",
    "1927",
    "1930",
    "1984",
    "1988",
    "1996",
    "2003",
    "2007",
    "2008",
    "2013",
    "2017",
    "2018",
    "2021",
  ]
  const eraArray = ["1800s", "1900s", "2000s", textPresent]

  const windowWidth = useWindowWidth()

  useEffect(() => {
    const copiedArray = [...slidesArray]
    copiedArray.forEach((item, index) => {
      if (currentIndex === index) {
        item.showAssets = true
      } else {
        item.showAssets = false
      }
    })
    setSlidesArray(copiedArray)
  }, [currentIndex])

  useEffect(() => {
    const yearPoints = document.querySelector(".slick-dots ul")
    const eraPoints = document.querySelector(`.${styles.era_slider} ul`)
    if (currentEra === "1800s") {
      for (let i = 0; i < yearPoints.children.length; i++) {
        if (i < 1 || i > 2) {
          yearPoints.children[i].style.display = "none"
        } else {
          yearPoints.children[i].style.display = "inline-block"
        }
      }
      if (windowWidth < 1440) {
        yearPoints.children[1].style.left = "-34%"
        yearPoints.children[2].style.left = "-31%"
      } else {
        yearPoints.children[1].style.left = "-36%"
        yearPoints.children[2].style.left = "-33%"
      }

      eraPoints.children[1].style.transform = "translateX(0)"
      eraPoints.children[2].style.transform = "translateX(0)"
    }

    if (currentEra === "1900s") {
      for (let i = 0; i < yearPoints.children.length; i++) {
        if (i <= 2 || i > 7) {
          yearPoints.children[i].style.display = "none"
        } else {
          yearPoints.children[i].style.display = "inline-block"
          if (windowWidth < 1440) {
            yearPoints.children[i].style.left = "-15px"
          } else {
            yearPoints.children[i].style.left = "-5px"
          }
        }
      }
      eraPoints.children[1].style.transform = "translateX(-100px)"
      eraPoints.children[2].style.transform = "translateX(100px)"
    }
    if (currentEra === "2000s" || currentEra === "Present") {
      for (let i = 0; i < yearPoints.children.length; i++) {
        if (i <= 7) {
          yearPoints.children[i].style.display = "none"
        } else {
          if (windowWidth < 1440) {
            yearPoints.children[i].style.display = "inline-block"
            yearPoints.children[i].style.left = "200px"
          } else {
            yearPoints.children[i].style.display = "inline-block"
            yearPoints.children[i].style.left = "220px"
          }
        }
      }
      eraPoints.children[1].style.transform = "translateX(-200px)"
      eraPoints.children[2].style.transform = "translateX(-400px)"
    }
    if (currentEra === "") {
      eraPoints.children[1].style.transform = "translateX(0)"
      eraPoints.children[2].style.transform = "translateX(0)"
    }
    if (windowWidth < 728) {
      if (
        currentIndex === 11 ||
        currentIndex === 12 ||
        currentIndex === 13 ||
        currentIndex === 14
      ) {
        yearPoints.children[11].setAttribute(
          "style",
          "display:inline-block !important"
        )
        yearPoints.children[12].setAttribute(
          "style",
          "display:inline-block !important"
        )
        yearPoints.children[13].setAttribute(
          "style",
          "display:inline-block !important"
        )
        yearPoints.children[14].setAttribute(
          "style",
          "display:inline-block !important"
        )
      }
    }
  }, [currentIndex, currentEra, windowWidth])

  useEffect(() => {
    if (currentIndex === 0) {
      setShowDragNotification(true)
      setTimeout(() => {
        setShowDragNotification(false)
      }, 5000)
    } else {
      setShowDragNotification(false)
    }
    if (windowWidth >= 1280) {
      if (currentIndex === 1) {
        setShowSkipNotification(true)
        setTimeout(() => {
          setShowSkipNotification(false)
        }, 5000)
      } else {
        setShowSkipNotification(false)
      }
    }
  }, [currentIndex])

  const [slidesArray, setSlidesArray] = useState([
    {
      images: [{ img: animation_content.timelineImage ? animation_content.timelineImage.fluid.src : ekaterra_tl, name: "timeline" }],
      showAssets: false,
      text: "",
      class: styles.slide_0,
      bgColor: "transparent",
    },
    {
      images: [
        {
          img: person1,
          name: "person1",
          variants: {
            hidden: {
              scale: 0,
              opacity: 0,
            },
            visible: {
              scale: 1,
              opacity: 1,
              transition: { duration: 1, ease: "easeInOut" },
            },
          },
        },
        { img: cup, name: "cup" },
        { img: car, name: "car" },
        { img: sign, name: "sign" },
      ],
      showAssets: false,
      text: animation_content.brookeBondText,
      class: styles.slide_1,
      bgColor: "#e7cba7",
    },
    {
      images: [
        {
          img: person2,
          name: "person2",
          variants: {
            hidden: {
              scale: 0,
              opacity: 0,
            },
            visible: {
              scale: 1,
              opacity: 1,
              transition: { duration: 1, ease: "easeInOut" },
            },
          },
        },
        { img: sign2, name: "sign2" },
      ],
      showAssets: false,
      text: animation_content.thomasJLipton,
      class: styles.slide_2,
      bgColor: "#a0c52d",
    },
    {
      images: [
        { img: bg, name: "bg" },
        { img: group2, name: "group2" },
        { img: group, name: "group" },
      ],
      showAssets: false,
      text: animation_content.vanDenBerghsInvests,
      class: styles.slide_3,
      bgColor: "#f1f1f1",
    },
    {
      images: [
        {
          img: log,
          name: "log",
          variants: {
            hidden: {
              x: "-100vh",
              opacity: 0,
            },
            visible: {
              x: 0,
              opacity: 1,
              transition: { duration: 1, ease: "easeInOut" },
            },
          },
        },
        {
          img: pg_logo,
          name: "pg_logo",
          variants: {
            hidden: {
              x: "500",
              opacity: 0,
            },
            visible: {
              x: 0,
              opacity: 1,
              transition: { duration: 1, ease: "easeInOut" },
            },
          },
        },
        {
          img: progress,
          name: "progress",
          variants: {
            hidden: {
              y: "-100vh",
              opacity: 0,
            },
            visible: {
              y: 0,
              opacity: 1,
              transition: { duration: 1, ease: "easeInOut" },
            },
          },
        },
      ],
      showAssets: false,
      text: mergeLeverBrothers,
      class: styles.slide_4,
      bgColor: "#c0d77f",
    },
    {
      images: [
        {
          img: redLabel,
          name: "redLabel",
          variants: {
            hidden: {
              y: "200",
              scale: 0,
              x: "200",
            },
            visible: {
              y: 0,
              scale: 1,
              x: 0,
              transition: { duration: 1.5, ease: "easeInOut" },
            },
          },
        },
        { img: redLabelLogo, name: "redLabelLogo" },
      ],
      showAssets: false,
      text: animation_content.brookeBondTea,
      class: styles.slide_5,
      bgColor: "#cab6d8",
    },
    {
      images: [
        {
          img: bushells,
          name: "bushells",
          variants: {
            hidden: {
              x: "100vw",
              opacity: 0,
            },
            visible: {
              x: 0,
              opacity: 1,
              transition: { duration: 1.5, ease: "easeInOut" },
            },
          },
        },
        {
          img: bushellsLogo,
          name: "bushellsLogo",
          variants: {
            hidden: {
              scale: 0,
              opacity: 0,
            },
            visible: {
              scale: 1,
              opacity: 1,
              transition: { duration: 1.5, ease: "easeInOut" },
            },
          },
        },
      ],
      showAssets: false,
      text: animation_content.bushellsHoldings,
      class: styles.slide_6,
      bgColor: "#a5daeb",
    },
    {
      images: [
        { img: carton, name: "carton" },
        {
          img: teaBag,
          name: "teaBag",
          variants: {
            hidden: {
              scale: 0,
              opacity: 0,
            },
            visible: {
              scale: 1,
              opacity: 1,
              transition: { duration: 1, ease: "easeInOut" },
            },
          },
        },
      ],
      showAssets: false,
      text: animation_content.pgTips,
      class: styles.slide_7,
      bgColor: "#e7cba7",
    },
    {
      images: [
        {
          img: glass,
          name: "glass",
          variants: {
            hidden: {
              y: "100",
              scale: 0,
              x: "200",
            },
            visible: {
              y: 0,
              scale: 1,
              x: 0,
              transition: { duration: 1.5, ease: "easeInOut" },
            },
          },
        },
        {
          img: carton2,
          name: "carton2",
          variants: {
            hidden: {
              y: "-200",
              scale: 0,
              x: "-200",
            },
            visible: {
              y: 0,
              scale: 1,
              x: 0,
              transition: { duration: 1.5, ease: "easeInOut" },
            },
          },
        },
        { img: teaBag2, name: "teaBag2" },
      ],
      showAssets: false,
      text: liptonIceTea,
      class: styles.slide_8,
      bgColor: "#c0d77f",
    },
    {
      images: [{ img: seal, name: "seal" }],
      showAssets: false,
      text: animation_content.rainforestAlliance,
      class: styles.slide_9,
      bgColor: "#a5daeb",
    },
    {
      images: [
        {
          img: liptonLogo,
          name: "liptonLogo",
          variants: {
            hidden: {
              scale: 5,
              opacity: 0,
            },
            visible: {
              scale: 1,
              opacity: 1,
              transition: { duration: 1 },
            },
          },
        },
        { img: carton3, name: "carton3" },
        {
          img: teaBag3,
          name: "teaBag3",
          variants: {
            hidden: {
              opacity: 0,
              x: "-500",
            },
            visible: {
              opacity: 1,
              x: 0,
              transition: { duration: 1 },
            },
          },
        },
      ],
      showAssets: false,
      text: animation_content.liptonFruit,
      class: styles.slide_10,
      bgColor: "#cab6d8",
    },
    {
      images: [{ img: bg2, name: "bg2" }],
      showAssets: false,
      text: animation_content.australiaTea,
      class: styles.slide_11,
      bgColor: "#a5daeb",
    },
    {
      images: [{ img: tazo, name: "tazo" }],
      showAssets: false,
      text: tazoHeading,
      class: styles.slide_12,
      bgColor: "#e7cba7",
    },
    {
      images: [{ img: pg_green, name: "pg_green" }],
      showAssets: false,
      text: animation_content.pgTipsBiodegradable,
      class: styles.slide_13,
      bgColor: "#f1f1f1",
    },
    {
      images: [
        {
          img: ekaterra_logo,
          name: "ekaterra_logo",
          variants: {
            hidden: {
              y: "100",
              scale: 0,
              x: "-200",
            },
            visible: {
              y: 0,
              scale: 1,
              x: 0,
              transition: { duration: 1, ease: "easeInOut" },
            },
          },
        },
      ],
      showAssets: false,
      text: animation_content.ekaterra,
      class: styles.slide_14,
      bgColor: "#c0d77f",
    },
  ])

  const opacity_Variants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: { duration: 1, ease: "easeInOut" },
    },
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    swipe: true,
    autoplay: true,
    autoplaySpeed: 7000,
    cssEase: "linear",
    pauseOnHover: true,
    appendDots: dots => (
      <div>
        <div
          className="timeline-bg-slides"
          style={{
            display:
              (windowWidth < 767 && currentIndex === 0) || windowWidth > 767
                ? "block"
                : "none",
            height: "2px",
            padding: "0 20px",
            backgroundColor: `${isTimelineWhite ? "white" : "#4E4E4E"}`,
            margin: "auto",
            transform:
              windowWidth < 1440
                ? currentIndex === 0
                  ? "translateY(18.5px)"
                  : "translateY(17px)"
                : currentIndex === 0
                ? "translateY(17.5px)"
                : "translateY(17px)",
            opacity: "1",
          }}
        ></div>
        <div
          style={{
            display: windowWidth < 767 && currentIndex !== 0 ? "block" : "none",
            height: "2px",
            padding: "0 20px",
            backgroundColor: `${isTimelineWhite ? "white" : "#4E4E4E"}`,
            margin: "auto",
            transform:
              windowWidth < 768
                ? currentIndex === 1
                  ? "translateY(17px) translateX(16%)"
                  : currentIndex === 14
                  ? "translateY(17px) translateX(-16%)"
                  : "translateY(17px)"
                : "translateY(17px)",
            opacity: "1",
            width: "100%",
          }}
        ></div>
        <ul style={{ margin: "0px", opacity: currentIndex === 0 ? "0" : "1" }}>
          {" "}
          {dots}{" "}
        </ul>
      </div>
    ),
    customPaging: i => (
      <div
        style={{
          display: `${isTimelineWhite ? "none" : "flex"}`,
          flexDirection: "column",
          alignItems: "center",
          margin: "0 10px",
          transform: "translateY(5px)",
        }}
        id={i + 1}
      >
        <div
          style={{
            backgroundColor:
              currentIndex === i
                ? slidesArray[currentIndex]?.bgColor
                : "transparent",
          }}
        >
          <div
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              cursor: "pointer",
              backgroundColor: "rgb(78, 78, 78)",
            }}
          ></div>
        </div>
        <span
          style={{
            fontFamily: "Bilo Bold",
            fontSize: "18px",
            color: "#4E4E4E",
            opacity: "60%",
          }}
        >
          {datesArray[i]}
        </span>
      </div>
    ),
    afterChange: function (index) {
      setCurrentIndex(index)
      if (index == 0) {
        setIsTimelineWhite(true)
      } else {
        setIsTimelineWhite(false)
      }
      if (index >= 1 && index <= 2) {
        setCurrentEra("1800s")
      } else if (index >= 3 && index <= 7) {
        setCurrentEra("1900s")
      } else if (index >= 8 && index < 14) {
        setCurrentEra("2000s")
      } else if (index === 14) {
        setCurrentEra("Present")
      } else {
        setCurrentEra("")
      }
    },
    beforeChange: (current, next) => {
      if (current === 14 && next === 0 && windowWidth < 768) {
        const yearPoints = document.querySelector(".slick-dots ul")
        yearPoints.style.opacity = "0"
      }
      if (current === 11 && next === 10 && next !== 12 && windowWidth < 768) {
        const yearPoints = document.querySelector(".slick-dots ul")
        yearPoints.children[14].style.opacity = "0"
      }
    },
  }
  return (
    <div className={styles.timeline_container}>
      <Slider {...settings} ref={sliderRef}>
        {slidesArray.map((slide, index) => {
          return (
            <div
              className={slide.class}
              key={index}
              style={{ maxWidth: "100%" }}
            >
              {index === 0 && (
                <motion.div
                  variants={opacity_Variants}
                  initial="hidden"
                  animate="visible"
                  key={"bannerbg"}
                  data-name={"bannerbg"}
                >
                  <Img
                    style={{ height: "100%" }}
                    loading="eager"
                    fluid={{ src: bannerbg }}
                    alt={"bannerbg"}
                  ></Img>
                </motion.div>
              )}
              {slide.showAssets && (
                <div>
                  {slide.images.map(el =>
                    el.variants ? (
                      <motion.div
                        variants={el.variants}
                        initial="hidden"
                        animate="visible"
                        key={el.name}
                        data-name={el.name}
                      >
                        <Img
                          style={{ height: "100%" }}
                          loading="eager"
                          fluid={{ src: el.img }}
                          alt={el.name}
                        ></Img>
                      </motion.div>
                    ) : (
                      <motion.div
                        variants={opacity_Variants}
                        initial="hidden"
                        animate="visible"
                        key={el.name}
                        data-name={el.name}
                      >
                        <Img
                          style={{ height: "100%" }}
                          loading="eager"
                          fluid={{ src: el.img }}
                          alt={el.name}
                        ></Img>
                      </motion.div>
                    )
                  )}
                  {typeof slide.text === "object" ? (
                    slide.text.map((text, index) => (
                      <motion.p
                        variants={opacity_Variants}
                        initial="hidden"
                        animate="visible"
                        key={slide.class + index}
                      >
                        {text}
                      </motion.p>
                    ))
                  ) : (
                    <motion.p
                      variants={opacity_Variants}
                      initial="hidden"
                      animate="visible"
                    >
                      {slide.text}
                    </motion.p>
                  )}
                </div>
              )}
            </div>
          )
        })}
      </Slider>
      {showSkipNotification && <img src={animation_content.skipNotification ? animation_content.skipNotification.fluid.src : skip_notif} alt="skip_notif"></img>}
      {showDragNotification && <img src={animation_content.dragToExplore ? animation_content.dragToExplore.fluid.src : drag_notif} alt="drag_notif"></img>}
      <div className={styles.arrow_wrapper}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21.222"
          height="37.121"
          viewBox="0 0 21.222 37.121"
          onClick={() => sliderRef.current.slickPrev()}
        >
          <path
            id="Icon_ionic-ios-arrow-back"
            data-name="Icon ionic-ios-arrow-back"
            d="M17.648,24.749,31.694,10.715a2.653,2.653,0,1,0-3.757-3.746l-15.913,15.9a2.648,2.648,0,0,0-.077,3.658L27.925,42.541a2.653,2.653,0,0,0,3.757-3.746Z"
            transform="translate(-11.251 -6.194)"
            fill={currentIndex === 0 ? "white" : "#474747"}
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21.222"
          height="37.121"
          viewBox="0 0 21.222 37.121"
          onClick={() => sliderRef.current.slickNext()}
        >
          <path
            id="Icon_ionic-ios-arrow-back"
            data-name="Icon ionic-ios-arrow-back"
            d="M26.075,24.749,12.03,10.715a2.653,2.653,0,0,1,3.757-3.746L31.7,22.871a2.648,2.648,0,0,1,.077,3.658L15.8,42.541a2.653,2.653,0,0,1-3.757-3.746Z"
            transform="translate(-11.251 -6.194)"
            fill={currentIndex === 0 ? "white" : "#474747"}
          />
        </svg>
      </div>
      <div
        className={`${styles.era_slider}`}
        style={{ display: currentIndex === 0 && "block" }}
      >
        <ul>
          {eraArray.map(era => {
            return (
              <li
                onClick={() => {
                  setCurrentEra(era)
                  if (era === "1800s") {
                    sliderRef.current.slickGoTo(1)
                  } else if (era === "1900s") {
                    sliderRef.current.slickGoTo(3)
                  } else if (era === "2000s") {
                    sliderRef.current.slickGoTo(8)
                  } else {
                    sliderRef.current.slickGoTo(14)
                  }
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      currentEra === era
                        ? slidesArray[currentIndex]?.bgColor
                        : "transparent",
                    border:
                      currentEra === era
                        ? "1.5px solid rgb(78, 78, 78)"
                        : "none",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: `${
                        isTimelineWhite ? "white" : "#4E4E4E"
                      }`,
                    }}
                  ></div>
                </div>
                <span
                  style={{
                    color: `${isTimelineWhite ? "white" : "#4E4E4E"}`,
                  }}
                >
                  {era}
                </span>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default TimelineContainer
